export default "__VITE_ASSET__DFQpCT8p__"